import {useRef, useEffect} from 'react';

// https://www.debuggr.io/react-update-unmounted-component/#bonus-tip
export default function useIsMountedRef() {
  const isMountedRef = useRef(null);
  useEffect(() => {
    isMountedRef.current = true;
    return () => isMountedRef.current = false;
  });
  return isMountedRef;
}